export const autoLeapData = Object.freeze({
  name: 'AutoLeap',
  logo: 'assets/alp_logo_transparent.png',
  email: 'admin@autoleap.com',
  phone: '(7215)-823-321',
  address: {
    addLine1: '330 Bay Street, Suite 820',
    country: 'Canada',
    state: 'ON',
    city: 'Toronto',
  },
});

export const AutoLeap = 'AutoLeap';
